import { useQuery } from '@tanstack/react-query';
import { USE_QUERY_CONSTANTS } from 'src/constants/constants';
import { ApiRoutes } from '../api/ApiRoutes';
import { useAxios } from '../api/AxiosContext';

export const useBannerListQuery = () => {
  const axios = useAxios();

  return useQuery(['banner-listing'], () => axios.get(`${ApiRoutes.bannerList}`), {
    select: res => res.data.data,
    keepPreviousData: true,
    cacheTime: USE_QUERY_CONSTANTS.cacheMs,
  });
};
